<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>{{ data.dialogTitle }}</mat-card-title>
        <div class="mat-card-header-buttons small">
            <button
                mat-mini-fab
                class="basic-button"
                [disabled]="uploader?.queue?.length > 50"
                aria-label="Ouvrir le carnet d’adresses"
                matTooltip="Ouvrir le carnet d’adresses"
                matTooltipPosition="below"
                (click)="displayContacts()">
                <fa-icon [icon]="addressbookIcon"></fa-icon>
            </button>
            <button
                mat-mini-fab
                class="basic-button"
                [disabled]="folderFilesSelected.length > 30"
                aria-label="Ajouter un fichier du dossier"
                matTooltip="Ajouter un fichier du dossier"
                matTooltipPosition="below"
                (click)="internalFileToAdd()">
                <fa-icon [icon]="internalFileIcon"></fa-icon>
            </button>
            <button
                mat-mini-fab
                class="basic-button"
                [disabled]="uploader?.queue?.length > 50"
                aria-label="Ajouter une pièce-jointe"
                matTooltip="Ajouter une pièce-jointe"
                matTooltipPosition="below"
                (click)="fileToUpload.click()">
                <fa-icon [icon]="attachmentIcon"></fa-icon>
            </button>
            <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" [hidden]="true" multiple="multiple" />
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field class="mat-form-field-sender">
                    <mat-label>Emetteur</mat-label>
                    <mat-select data-select-address [formControl]="senderAddressFormControl">
                        <mat-option data-select-listing-type-option [value]="-1">Par défaut</mat-option>
                        @for (address of senderAddresses; track address.id) {
                            <mat-option data-select-listing-type-option [value]="address.id">{{ address.address }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="form-item">
                <mat-form-field class="mat-form-field-address">
                    <mat-label>Destinataires</mat-label>
                    <mat-chip-grid #toChipList multiple [formControl]="addressToFormControl" required>
                        @for (item of email.to; track $index) {
                            <mat-chip-row selectable="false" removable="true" (removed)="removeAddress(item, AddressType.to)">
                                {{ item }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                        }
                        <input
                            tabindex="1"
                            class="address-input"
                            [matChipInputFor]="toChipList"
                            [formControl]="addressToInputFormControl"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            matChipInputAddOnBlur="true"
                            (matChipInputTokenEnd)="addAddress($event, AddressType.to)"
                            (paste)="addressesToPaste($event, AddressType.to)" />
                    </mat-chip-grid>
                    @if (email.to.length === 0 && (addressToFormControl?.dirty || addressToFormControl?.touched) && addressToFormControl.hasError('required')) {
                        <mat-error>Le champ destinataires est obligatoire</mat-error>
                    }
                    @if (addressToFormControl.hasError('invalidFormat') && (addressToFormControl?.dirty || addressToFormControl?.touched)) {
                        <mat-error>L'adresse mail est invalide</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-address address-cc">
                    <mat-label>CC</mat-label>
                    <mat-chip-grid #ccChipList [formControl]="addressCcFormControl" multiple>
                        @for (item of email.cc; track $index) {
                            <mat-chip-row selectable="false" removable="true" (removed)="removeAddress(item, AddressType.cc)">
                                {{ item }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                        }
                        <input
                            tabindex="2"
                            class="address-input"
                            [matChipInputFor]="ccChipList"
                            [formControl]="addressCcInputFormControl"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            matChipInputAddOnBlur="true"
                            (matChipInputTokenEnd)="addAddress($event, AddressType.cc)"
                            (paste)="addressesToPaste($event, AddressType.cc)" />
                    </mat-chip-grid>
                    @if (addressCcFormControl.hasError('invalidFormat') && (addressCcFormControl?.dirty || addressCcFormControl?.touched)) {
                        <mat-error>L'adresse email est incorrecte</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-address address-cci">
                    <mat-label>CCI</mat-label>
                    <mat-chip-grid #cciChipList [formControl]="addressCciFormControl" multiple>
                        @for (item of email.cci; track $index) {
                            <mat-chip-row selectable="false" removable="true" (removed)="removeAddress(item, AddressType.cci)">
                                {{ item }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                        }
                        <input
                            tabindex="3"
                            class="address-input"
                            [matChipInputFor]="cciChipList"
                            [formControl]="addressCciInputFormControl"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            matChipInputAddOnBlur="true"
                            (matChipInputTokenEnd)="addAddress($event, AddressType.cci)"
                            (paste)="addressesToPaste($event, AddressType.cci)" />
                    </mat-chip-grid>
                    @if (addressCciFormControl.hasError('invalidFormat') && (addressCciFormControl?.dirty || addressCciFormControl?.touched)) {
                        <mat-error>L'adresse email est incorrecte</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-subject">
                    <mat-label>Sujet</mat-label>
                    <input tabindex="4" matInput [formControl]="subjectFormControl" required />
                    @if (subjectFormControl.hasError('required') && (subjectFormControl?.dirty || subjectFormControl?.touched)) {
                        <mat-error>Le sujet est obligatoire</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="body-container">
                <p class="body-placeholder" [ngClass]="{ 'body-placeholder-error': bodyFormControl.hasError('required') && (bodyFormControl?.dirty || bodyFormControl?.touched) }">
                    Message *
                </p>
                <angular-editor tabindex="5" [config]="config" [formControl]="bodyFormControl"></angular-editor>
                @if (bodyFormControl.hasError('required') && (bodyFormControl?.dirty || bodyFormControl?.touched)) {
                    <mat-error class="body-error">Le corp du message est obligatoire</mat-error>
                }
            </div>
            <div class="attachments-and-files-container">
                <div class="attachments-container">
                    <p class="attachments-placeholder">Pièces-jointes</p>
                    @if (uploader.queue.length === 0) {
                        <p class="no-attachment-text">Aucune pièce-jointe</p>
                    } @else {
                        <table class="table-add-file">
                            <thead>
                                <tr>
                                    <th width="470px">Nom du fichier</th>
                                    <th width="130px">Taille</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (item of uploader.queue; track $index) {
                                    <tr>
                                        <td>{{ item?.file?.name | slice: 0 : 60 }}{{ item?.file?.name.length > 60 ? '...' : '' }}</td>
                                        <td>{{ item?.file?.size | avmFileSize }}</td>
                                        <td>
                                            <mat-icon (click)="item.remove()">delete</mat-icon>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
                <div class="folder-files-container">
                    <p class="folder-files-placeholder">Fichier</p>
                    @if (folderFilesSelected.length === 0) {
                        <p class="no-folder-files-text">Aucun fichier</p>
                    } @else {
                        <table class="table-add-file">
                            <thead>
                                <tr>
                                    <th width="470px">Nom du fichier</th>
                                    <th width="130px">Taille</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (file of folderFilesSelected; track file.id) {
                                    <tr>
                                        <td>{{ file?.name | slice: 0 : 60 }}{{ file?.name.length > 60 ? '...' : '' }}</td>
                                        <td>{{ file?.size | avmFileSize }}</td>
                                        <td>
                                            <mat-icon (click)="deleteFolderFile(file)">delete</mat-icon>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        </div>
        <ngx-spinner name="send-email-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Fermer</button>
        <button mat-raised-button class="accent-button" (click)="delete()" [disabled]="false">Supprimer</button>
        <button mat-raised-button class="accent-button" (click)="save()" [disabled]="false">Enregistrer le brouillon</button>
        <button mat-raised-button class="accent-button" (click)="send()" [disabled]="false">Confirmer l'envoi</button>
    </mat-card-actions>
</mat-card>
